const domain = "accenture.com";
export const SponsorTeam = [
  {
    leadershipTeam: [
      {
        id: 1,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:divya.dhar@${domain}`,
        "profile-link": "https://wd103.myworkday.com/accenture/d/inst/1$247/247$1117850.htmld#TABTASKID=2998%2440311",
        "team-designation": "Sponsor, ABC University",
      },
      {
        id: 1,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:anupama.nithyanand@${domain}`,
        "profile-link":
          "#",
        "team-designation": "Sponsor, ABC University",
      },
      {
        id: 2,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:ananya.e.ghosh@${domain}`,
        "profile-link":
          "https://wd103.myworkday.com/accenture/d/inst/1$247/247$1075303.htmld#TABTASKID=2998%2440311",
        "team-designation": "Sponsor, ABC University",
      },
      {
        id: 3,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:vanitadevi.patil@${domain}`,
        "profile-link":
          "#",
        "team-designation": "Sponsor, ABC University",
      },
    ],
    coreTeam: [
      {
        id: 4,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:h.srinivasan@${domain}`,
        "profile-link": "https://wd103.myworkday.com/accenture/d/inst/1$247/247$1104303.htmld#TABTASKID=2998%2440311",
        "team-designation": "L&TT",
      },

      {
        id: 3,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:savita.chaugule@${domain}`,
        "profile-link":
          "#",
        "team-designation": "ABC Account",
      },
      {
        id: 2,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:saradha.hariharan@${domain}`,
        "profile-link":
          "https://wd103.myworkday.com/accenture/d/inst/1$247/247$971908.htmld#TABTASKID=2998%2440311",
        "team-designation": "ABC Account",
      },

      {
        id: 5,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:varsha.a.tyagi@${domain}`,
        "profile-link":
          "https://wd103.myworkday.com/accenture/d/inst/1$247/247$787095.htmld#TABTASKID=2998%2440311",
        "team-designation": "L&TT",
      },
      {
        id: 6,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:nilakshi.barman@${domain}`,
        "profile-link":
          "https://wd103.myworkday.com/accenture/d/inst/1$247/247$1931084.htmld#TABTASKID=2998%2440311",
        "team-designation": "L&TT",
      },
      {
        id: 7,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:sucharitha.karanam@${domain}`,
        "profile-link":
          "https://wd103.myworkday.com/accenture/d/inst/1$247/247$2022057.htmld#TABTASKID=2998%2440311",
        "team-designation": "L&TT",
      },
      {
        id: 8,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:uma.rani.battu@${domain}`,
        "profile-link":
          "https://wd103.myworkday.com/accenture/d/inst/1$247/247$1882558.htmld#TABTASKID=2998%2440311",
        "team-designation": "L&TT",
      },
      {
        id: 9,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:reshmi.haridas.m@${domain}`,
        "profile-link":
          "https://wd103.myworkday.com/accenture/d/inst/1$247/247$1948061.htmld#TABTASKID=2998%2440311",
        "team-designation": "L&TT",
      },
      {
        id: 10,
        "team-img": "images/Sponsors/Profile1.png",
        "team-name": "xyz",
        enterprise: `mailto:rajath.mb@${domain}`,
        "profile-link": "#",
        "team-designation": "L&TT",
      },
    ],
  },
];
